import React, { FC, memo } from 'react'

import clsx from 'clsx'
import Tooltip from 'rc-tooltip'

import { ReactComponent as HelpCircle } from 'Icons/help-circle.svg'
import { ShopAppliedDiscountCode } from 'Types'

import TooltipOverlay from './TooltipOverlay'

interface DiscountsProps {
  appliedDiscountCodes: ShopAppliedDiscountCode[]
  hidden?: boolean
  totalDiscountMoneyFormatted: string
}

const Discounts: FC<DiscountsProps> = ({ appliedDiscountCodes, hidden, totalDiscountMoneyFormatted }) => {
  const isSingleCode = appliedDiscountCodes.length == 1

  return (
    <li
      className={clsx('checkout-order__discounts', {
        ['checkout-order__discounts_single']: isSingleCode,
      })}
      hidden={hidden}
    >
      <span>Discount total</span>
      <span>{totalDiscountMoneyFormatted}</span>
      <div>
        {appliedDiscountCodes.map((code) => (
          <div key={code.id} className="checkout-order__discount">
            <span>{code.name}</span>
            <Tooltip overlay={<TooltipOverlay code={code} />} placement="bottom" trigger="hover">
              <HelpCircle className="checkout-order__tooltip / mr-auto / ml-1 / sociavore-icon" />
            </Tooltip>
            {!isSingleCode ? <span className="pl-2">{code.discountMoneyFormatted}</span> : null}
          </div>
        ))}
      </div>
    </li>
  )
}

export default memo(Discounts)
